function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_ionic-ios-timer",
  "data-name": "Icon ionic-ios-timer",
  transform: "translate(0 0)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1444",
  "data-name": "Path 1444",
  d: "M19.251,34.564A15.313,15.313,0,0,1,8.623,8.225a1.229,1.229,0,1,1,1.707,1.769A12.851,12.851,0,1,0,20.476,6.457V11.25a1.233,1.233,0,0,1-2.465,0V5.17a1.232,1.232,0,0,1,1.233-1.233,15.313,15.313,0,0,1,.008,30.626Z",
  transform: "translate(-3.938 -3.938)",
  fill: "#596375"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1445",
  "data-name": "Path 1445",
  d: "M12.96,11.454l10.711,7.7A3.241,3.241,0,1,1,19.9,24.425a3.129,3.129,0,0,1-.754-.754l-7.7-10.711a1.08,1.08,0,0,1,1.507-1.507Z",
  transform: "translate(-4.809 -4.808)",
  fill: "#596375"
}));

var SvgIconIosTimer = function SvgIconIosTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.619,
    height: 30.626,
    viewBox: "0 0 30.619 30.626",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconIosTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-ios-timer.0fc95346.svg";
export { ForwardRef as ReactComponent };